import { Table } from "antd";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { EyeFilled } from "@ant-design/icons";

import { FinderTaxpayers } from "components";
import { useTaxpayers } from "services/taxpayers.service";

import { routeTaxpayer } from "routes/pages";
interface Props {
  itemsPerPage?: number;
  partnerId?: number;
}

export function TaxpayersTable(props: Props) {
  const { itemsPerPage = 10, partnerId } = props;
  const initFilters = {
    page: 1,
    limit: itemsPerPage,
    skid: null,
    rfc: null,
    fullName: null,
    email: null,
    phone: null,
    partnerId: partnerId,
  };

  const urlHistory = useHistory();
  const [value, setValue] = useState("");
  const [filterTax, setFilter] = useState(initFilters);
  const [searchFilters, setSearchFilters] = useState("");

  const taxpayers = useTaxpayers({ filters: filterTax });

  const fetchTaxpayers = (filter: string, valueFilter: string, page?: number) => {
    setSearchFilters(filter);
    setValue(valueFilter);
    switch (filter) {
      case "skid":
        setFilter({
          page: page,
          limit: itemsPerPage,
          skid: valueFilter,
          rfc: null,
          fullName: null,
          email: null,
          phone: null,
          partnerId: partnerId,
        });
        break;
      case "rfc":
        setFilter({
          page: page,
          limit: itemsPerPage,
          skid: null,
          rfc: valueFilter,
          fullName: null,
          email: null,
          phone: null,
          partnerId: partnerId,
        });
        break;
      case "name":
        setFilter({
          page: page,
          limit: itemsPerPage,
          skid: null,
          rfc: null,
          fullName: valueFilter.toUpperCase(),
          email: null,
          phone: null,
          partnerId: partnerId,
        });
        break;
      case "email":
        setFilter({
          page: page,
          limit: itemsPerPage,
          skid: null,
          rfc: null,
          fullName: null,
          email: valueFilter,
          phone: null,
          partnerId: partnerId,
        });
        break;
      case "phone":
        setFilter({
          page: page,
          limit: itemsPerPage,
          skid: null,
          rfc: null,
          fullName: null,
          email: null,
          phone: valueFilter,
          partnerId: partnerId,
        });
        break;
      default:
        setFilter({
          page: page,
          limit: itemsPerPage,
          skid: null,
          rfc: null,
          fullName: null,
          email: null,
          phone: null,
          partnerId: partnerId,
        });
        break;
    }
  };

  const handleClickGoToTaxpayerView = (item) => urlHistory.push(routeTaxpayer({ taxpayerId: item.id }));

  function handlePagination(page) {
    fetchTaxpayers(searchFilters, value, page);
  }

  return (
    <>
      <FinderTaxpayers doSearch={fetchTaxpayers} />
      <Table
        bordered
        scroll={{ x: true }}
        loading={{ spinning: taxpayers?.isLoading || taxpayers?.isFetching, size: "small" }}
        locale={{ emptyText: "Sin resultados" }}
        dataSource={(Array.isArray(taxpayers?.data?.data)
          ? taxpayers.data.data
          : Array.isArray(taxpayers?.data) ? taxpayers.data : []
        ).map((item, idx) => ({
          ...item,
          key: item?.id ?? `${item?.rfc ?? "row"}-${idx}`,
          rfc: item?.rfc,
          name: item?.name,
          skid: item?.skid,
          state: item?.state,
          full_address: item?.address,
        }))}
        pagination={{
          current: filterTax.page,
          pageSize: itemsPerPage,
          total: taxpayers?.data?.total ?? taxpayers?.data?.count ?? 0,
          showSizeChanger: false,
          onChange: handlePagination,
          hideOnSinglePage: true,
        }}
        columns={[
          {
            key: "view",
            title: "Ver",
            render: (rowData) => (
              <EyeFilled style={{ fontSize: "1.4rem" }} onClick={() => handleClickGoToTaxpayerView(rowData)} />
            ),
          },
          {
            dataIndex: "rfc",
            title: "RFC",
            key: "rfc",
          },
          {
            dataIndex: "name",
            title: "Nombre",
            key: "name",
          },
          {
            dataIndex: "skid",
            title: "SKID",
            key: "skid",
          },
          {
            dataIndex: "state",
            title: "Estado",
            key: "state",
          },
          {
            dataIndex: "full_address",
            title: "Dirección",
            key: "full_address",
          },
        ]}
      />
    </>
  );
}
